// import Vue from 'vue';
import { Notify } from 'vant'
import axios from 'axios'
import qs from 'qs'
import router from '@/router'

//const baseUrl = 'http://47.111.163.93:8088'
const http = axios.create({
  baseURL: '/',
  timeout: 1000 * 60 * 2, //请求超时两分钟
  // withCredentials: true,
  paramsSerializer: (params) => {
    return qs.stringify(params, { indices: false })
  },
})

//http.defaults.headers.post['Content-Type'] = 'application/json'

/**
 * 请求拦截
 */
http.interceptors.request.use(
  (config) => {
    //config.url = baseUrl + config.url
    // config.headers['wyd-token'] = document.cookie.match(new RegExp(`XSRF-TOKEN=([^;]+)`)) ? document.cookie.match(new RegExp(`XSRF-TOKEN=([^;]+)`))[1] : null // 请求头带上token
    config.headers['Authorization'] = localStorage.getItem('porsche-token') // 请求头带上token
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

/**
 * 响应拦截
 */
http.interceptors.response.use(
  (res) => {
    //console.log('res', res.data)

    return res.data
  },
  (error) => {
    if (error.response.status == 403) {
      localStorage.clear()
      Notify({ type: 'warning', message: '登录状态失效' })
      router.push('/login')
    }
    //if(error.response.status==401){
    // Message.warning('登录状态已失效')
    //   delete localStorage.token
    //   router.push('/signin')
    //}
    // Message.error(error.response.data.message, 5*1000)
    return Promise.reject(error)
  }
)
export default http
